// Styles
import '../css/cta.css';
import '../css/featured-post.css';
import '../css/hero-slider.css';
import '../css/news-ticker.css';
import '../css/post-layout-1.css';
import '../css/post-layout-2.css';
import '../css/post-layout-3.css';
import '../css/post-layout-4.css';
import '../css/post-layout-5.css';
import '../css/post-slider.css';
import '../css/service.css';

// scripts
import './widget/hero-slider';
import './widget/news-ticker';
import './widget/post-slider'